import { useState } from "react";

/**
 * Today's local midnight, fixed for the component's life (#1557). A page left
 * open past midnight keeps yesterday's date until it remounts; the stage comes
 * from the server, so only the flags and the When filter lag.
 */
export function useToday(): Date {
  const [today] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  });
  return today;
}
